import { Chat, ChatAiCompletion } from './types'
import { notify } from '~/utils/notify'

type AiCompletionDataBasic = {
  chat: string
  requestId: string
}

type AiCompletionDataDone = AiCompletionDataBasic & {
  type: 'done'
}

type AiCompletionDataError = AiCompletionDataBasic & {
  type: 'error'
  code: number
}

type AiCompletionDataContent = AiCompletionDataBasic & {
  type: 'content'
  content: string
}

type AiCompletionData =
  | AiCompletionDataDone
  | AiCompletionDataError
  | AiCompletionDataContent

export const aiCompletionStart =
  (setChats: React.Dispatch<React.SetStateAction<Chat[]>>) =>
  (chatId: string, requestId: string, type: string) => {
    setChats(chats =>
      chats.map(chat => {
        if (chat.id != chatId) {
          return chat
        }

        return {
          ...chat,
          aiCompletion: {
            requestId,
            content: '',
            done: false,
            error: false,
            type,
          },
        }
      })
    )
  }

export const aiCompletionApplied =
  (setChats: React.Dispatch<React.SetStateAction<Chat[]>>) =>
  (chatId: string) => {
    setChats(chats =>
      chats.map(chat => {
        if (chat.id != chatId) {
          return chat
        }

        return {
          ...chat,
          aiCompletion: undefined,
        }
      })
    )
  }

export const handleAiCompletionData = async (
  setChats: React.Dispatch<React.SetStateAction<Chat[]>>,
  data: AiCompletionData
) => {
  setChats(chats =>
    chats.map(chat => {
      if (chat.id != data.chat) {
        return chat
      }

      if (!chat.aiCompletion || chat.aiCompletion.requestId != data.requestId) {
        return chat
      }

      const oldChatAiCompletion = chat.aiCompletion

      const newChatAiCompletion: ChatAiCompletion | undefined = (() => {
        switch (data.type) {
          case 'done':
            return {
              ...oldChatAiCompletion,
              done: true,
            }
          case 'error':
            notify(
              'The AI server is not responding. Please try again later',
              'warning'
            )

            return undefined
          case 'content':
            return {
              ...oldChatAiCompletion,
              content: oldChatAiCompletion.content + data.content,
            }
        }
      })()

      return {
        ...chat,
        aiCompletion: newChatAiCompletion,
      }
    })
  )
}
